// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-form .mobile-icon {\n  position: relative;\n}\n.vue-form .mobile-icon .el-icon {\n  position: absolute;\n  right: 2%;\n  top: 38%;\n  opacity: 0.3;\n}\n.vue-form .additonal-fax {\n  display: flex;\n  gap: 20px;\n}\n.active-tabs {\n  color: #eb5757;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
